import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import {
  Grid,
} from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const Transporte = ({widthFull}: {widthFull: string}) => {


  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt:1 }}
    >

      <Placa widthFull={widthFull} />
      <PlacaCabezal widthFull={widthFull} />
    </Grid>
  );
};


const Placa = ({widthFull}: {widthFull: string}) => {
  const {
    open: openPlacaCabezal,
    handleClose: handleClosePlacaCabezal,
    handleOpen: handleOpenPlacaCabezal,
  } = useOpen();

  const placaPhoto = useWorkflowStore((state) => state.placaPhoto);
  const setPlacaPhoto = useWorkflowStore((state) => state.setPlacaPhoto);

  const fotoUrl = useBlobUrl(placaPhoto);

  return (
    <Grid item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleClosePlacaCabezal}
        handleOpen={handleOpenPlacaCabezal}
        label="PLACA"
        open={openPlacaCabezal}
        setFoto={setPlacaPhoto}
        width={widthFull === "xs" ? 180 : 130}
        fontSize={widthFull === "xs" ? 9 : 10}
      />
    </Grid>

  )
}


const PlacaCabezal = ({widthFull}: {widthFull: string}) => {

  const {
    open: openPlacaCabezal1,
    handleClose: handleClosePlacaCabezal1,
    handleOpen: handleOpenPlacaCabezal1,
  } = useOpen();

  const cabezalPhoto = useWorkflowStore((state) => state.cabezalPhoto);
  const setCabezalPhoto = useWorkflowStore((state) => state.setCabezalPhoto);
  const fotoUrl = useBlobUrl(cabezalPhoto);


  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleClosePlacaCabezal1}
        handleOpen={handleOpenPlacaCabezal1}
        label="CABEZAL"
        open={openPlacaCabezal1}
        setFoto={setCabezalPhoto}
        width={widthFull === "xs" ? 180 : 130}
        fontSize={widthFull === "xs" ? 9 : 10}
      />
    </Grid>
  )
}